module.exports = __webpack_public_path__ + "img/serviceDetail0.fae020bb.png";